
import React from "react";
import InfoTooltip from "@/components/ui/info-tooltip";

interface StatItemProps {
  label: string;
  value: string;
  icon: React.ReactNode;
  valueColor?: string;
  tooltip?: string;
  infoIconColor?: string; // Add this prop
}

const StatItem = ({ 
  label, 
  value, 
  icon, 
  valueColor = "", 
  tooltip, 
  infoIconColor = "#555555" // Default dark grey
}: StatItemProps) => {
  return (
    <div className={`p-3 rounded-lg bg-[#0F1B2C]/20`}>
      <div className="flex items-center gap-2 mb-1">
        {icon}
        <span className="text-white/70 text-xs">{label}</span>
        {tooltip && (
          <InfoTooltip 
            content={tooltip} 
            side="top" 
            className={`text-white/50 hover:text-white`}
            infoIconColor={infoIconColor} // Pass the color to InfoTooltip
          />
        )}
      </div>
      <div className={`text-lg font-semibold ${valueColor || "text-white"}`}>
        {value}
      </div>
    </div>
  );
};

export default StatItem;
